import { lazy } from "react";
import { defineWebModule } from "../../web/module";
import "./web/reports.css";

// Pages load when opened, so the app starts fast on a phone with weak signal.
const ReportsSection = lazy(() => import("./web/ReportsSection").then((m) => ({ default: m.ReportsSection })));
const WorklistJob = lazy(() => import("./web/WorklistJob").then((m) => ({ default: m.WorklistJob })));
const WorklistsWorkspace = lazy(() => import("./web/Workspace").then((m) => ({ default: m.WorklistsWorkspace })));

export default defineWebModule({
  id: "reports",
  ranchSections: { reports: ReportsSection },
  workspaces: { "report-worklists": WorklistsWorkspace },
  jobs: { "reports.worklist": WorklistJob },
});

export { cattleReportLink } from "./web/link";
